angular.module('harriApp')
    .factory('hEvent', ['$location', '$q', '$urlRouter', function($location, $q, $urlRouter) {
        var event = {};
        var isImpersonate;

        var isAnalyticsEnabled = function() {
            return !isImpersonate && publicConfiguration.isAnalyticsEnabled();
        };

        event.track = function(eventName, data, callback) {

            if (!isAnalyticsEnabled()) {
                return callback && callback();
            }

            if(!data) {
                data = {};
            }

            event.getSegment().then(function() {
                analytics.track(eventName, data, function(){
                    if (callback) {
                        callback();
                    }
                });
            });
        };

        event.identify = function(data, integrations) {
            var userToIdentify = angular.copy(data);
            isImpersonate = false;

            if (data && data.impersonate) {
                userToIdentify = {};
                isImpersonate = true;
            }

            event.getSegment().then(function() {
                var copy = {};
                for (var k in userToIdentify) {
                    copy[k] = angular.copy(userToIdentify[k]);
                }

                if (userToIdentify.id) {

                    if (userToIdentify['entry_mode']) {
                        copy['brand_id'] = userToIdentify['entry_mode']['brand_id'];
                        copy['brand_name'] = userToIdentify['entry_mode']['brand_name'];
                        copy['brand_type'] = userToIdentify['entry_mode']['brand_type'];
                    }

                    // remove sensitive data because it stores in local storage
                    delete copy['email'];
                    delete copy['phone'];
                    delete copy['first_name'];
                    delete copy['last_name'];


                    analytics.identify(userToIdentify.id, copy, {
                        integrations: integrations || {
                            'All': false,
                            'Google Analytics': true,
                            'Facebook Pixel': true,
                            'Gainsight PX': true,
                            'Aptrinsic': true
                        }
                    });

                    try {
                        window.ga('set', 'userId', userToIdentify.id.toString());
                    }
                    catch (e) {
                        console.error("Failed to set user id for Google Analytics, ga:", window.ga);
                    }
                }
                else {
                    analytics.reset();
                }
            });
        };

        event.reset = function() {
            analytics.reset();
        };

        event.identifyOnPageView = function (user, pageName) {
            var data = angular.copy(user);
            data['page_name'] = pageName;
            data['random'] = Math.floor(Math.random() * 1000000000);
            data['current_page'] = window.location.protocol + "//" + window.location.host + $location.path();
            event.identify(data, {
                    'All': false,
                }
            )
        };

        var firstRequest = true;
        var lastPage;

        event.pageView = function(pageName, path, title, user_type) {

            if (!isAnalyticsEnabled()) {
                return;
            }

            event.getSegment().then(function() {

                var segmentData = {
                    title: title,
                    url: window.location.protocol + "//" + window.location.host + path,
                    path: path,
                    user_type: user_type,
                    category: 'page_views',
                    label: path,
                    referrer: window.referer
                };

                setTimeout(function(){
                    firstRequest = false;

                    if (window.location.pathname !== lastPage){
                        analytics.page(pageName, segmentData, {
                            integrations: {
                                'All': true,
                                'Gainsight PX Cloud Server': false
                            }
                        });

                        lastPage = window.location.pathname;
                    }
                }, 2);
            });
        };

        /**
         * segment
         */
        //https://segment.com/docs/libraries/analytics.js/
        event.initSegmentPromise = null;
        event.getSegment = function() {
            //return the current promise
            if(event.initSegmentPromise) {
                return event.initSegmentPromise;
            }

            //create a new promise if not already created.
            var defer = $q.defer();
            event.initSegmentPromise = defer.promise;

            //run the code on deployed servers only
            if(!isAnalyticsEnabled()) {
                return event.initSegmentPromise;
            }

            // Create a queue, but don't obliterate an existing one!
            window.analytics = window.analytics || [];

            // A list of the methods in Analytics.js to stub.
            window.analytics.methods = ['identify', 'group', 'track',
                'page', 'alias', 'ready', 'on', 'once', 'off', 'reset',
                'trackLink', 'trackForm', 'trackClick', 'trackSubmit'];

            // Define a factory to create stubs. These are placeholders
            // for methods in Analytics.js so that you never have to wait
            // for it to load to actually record data. The `method` is
            // stored as the first argument, so we can replay the data.
            window.analytics.factory = function(method){
                return function(){
                    var args = Array.prototype.slice.call(arguments);
                    args.unshift(method);
                    window.analytics.push(args);
                    return window.analytics;
                };
            };

            // For each of our methods, generate a queueing stub.
            for (var i = 0; i < window.analytics.methods.length; i++) {
                var key = window.analytics.methods[i];
                window.analytics[key] = window.analytics.factory(key);
            }

            // Define a method to load Analytics.js from our CDN,
            // and that will be sure to only ever load it once.
            window.analytics.load = function() {
                var key = publicConfiguration.getSegmentKey();
                var url = 'http://cdn.segment.com/analytics.js/v1/%key%/analytics.min.js';

                if('https:' === document.location.protocol) {
                    url = url.replace('http:', 'https:');
                }

                url = url.replace('%key%', key);

                $.getScript(url, function(data, textStatus, jqxhr) {
                        if(jqxhr.status == 200) {
                            defer.resolve();
                        } else {
                            defer.reject();
                        }
                    }
                );
            };

            // Add a version to keep track of what's in the wild.
            window.analytics.SNIPPET_VERSION = '2.0.9';

            // Load Analytics.js with your key, which will automatically
            // load the tools you've enabled for your account. Boosh!

            window.analytics.load();

            return event.initSegmentPromise;
        };

        event.setGlobalContext = function (data) {
            event.getSegment().then(function () {
                typeof aptrinsic != "undefined" && aptrinsic('set', 'globalContext', data)
            })
        }

        event.watchForms = function() {

            if(!isAnalyticsEnabled() || publicConfiguration.analytics["enable-form-analytics"]!==true) {
                return; //save memory
            };

            var textFieldsSelector = 'input[type!=checkbox][type!=radio]:not(.select2-input, .select2-offscreen), textarea';
            var checkboxesSelector = 'input[type=checkbox]';
            var radioSelector = 'input[type=radio]';
            var buttons = 'button:not(.confirm, .cancel, .close), div[ng-click], div.btn';

            $(document).on('focus', textFieldsSelector, function() {
                event.formEvent(this, 'enter', 'input');
            });

            $(document).on('blur', textFieldsSelector, function() {
                event.formEvent(this, 'exit', 'input');
            });

            $(document).on('change', checkboxesSelector, function() {
                event.formEvent(this, 'change', 'checkbox');
            });

            $(document).on('change', radioSelector, function() {
                event.formEvent(this, 'change', 'radio');
            });

            $(document).on('click', buttons, function() {
                event.formEvent(this, 'click', 'button');
            });

        };
        event.formEvent = function(element, eventName, type, data) {

            if(!isAnalyticsEnabled() || publicConfiguration.analytics["enable-form-analytics"]!==true) {
                return; //save memory
            };

            element = $(element);
            var form = element.closest('h-form');
            var view = '';

            if(!form) {
                //nearest form element
                form = element.closest('form');
                if(form) {
                    view = form.attr('action') ? form.attr('action') :
                        (
                            form.attr('name')?form.attr('name'):
                                (
                                    form.attr('id')?form.attr('id'):''
                                    )
                            );
                }
            } else {
                //h-form
                view = form.attr('view');
            }

            //element id
            var elementName = '';
            if(type!='button') {
                elementName = element.attr('name')?element.attr('name'):(
                    element.attr('id')?element.attr('id'):''
                );
            } else {
                elementName = $.trim(element.text());
            }


            var obj = {action: eventName, field: elementName, form:view, type:type, url:$location.path()};

            if(type == 'input') {
                var length = (element.val() || "").length;
                obj.length = length;
            } else if(type == 'checkbox') {
                obj.checked = (element.is(':checked') == true);
            } else if(type == 'radio') {
                obj.selected = element.val();
            }

            if(data) {
                for(var k in data) {
                    obj[k] = data[k];
                }
            }

            event.track('input', obj);
        };
        event.watchForms();


        //init segment
        event.getSegment();


        return event;
    }]);
